import { Phone, Mail, Clock } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { CONTACT, FAQ } from "@/data/site";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-20 lg:py-28">
    <div className="max-w-3xl mx-auto px-5 sm:px-8">
      <SectionHead center title="FAQ" className="mb-10" />
      <Reveal>
        <Accordion type="single" collapsible className="border-t border-white/10">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`q${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left text-base font-medium py-5 hover:no-underline hover:text-[#ffffff]">{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-300 text-[15px] leading-relaxed pr-8">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
      <Reveal>
        <div id="contact" data-testid="contact-card" className="mt-12 panel p-6 sm:p-7">
          <div className="text-sm text-slate-400">More questions? Talk to {CONTACT.owner}, owner of {CONTACT.business}.</div>
          <div className="mt-4 grid sm:grid-cols-3 gap-3">
            <a href={CONTACT.phoneHref} data-testid="contact-phone" className="btn-line justify-start normal-case tracking-normal font-sans font-medium text-sm px-4 py-3"><Phone className="h-4 w-4 text-[#d5d9df]" /> {CONTACT.phone}</a>
            <a href={`mailto:${CONTACT.email}`} data-testid="contact-email" className="btn-line justify-start normal-case tracking-normal font-sans font-medium text-sm px-4 py-3 min-w-0"><Mail className="h-4 w-4 text-[#d5d9df] shrink-0" /> <span className="truncate">{CONTACT.email}</span></a>
            <div data-testid="contact-availability" className="flex items-center gap-2 text-sm px-4 py-3 rounded-lg border border-white/10"><Clock className="h-4 w-4 text-[#d5d9df]" /> Open {CONTACT.hours}</div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
